export const smsCodeCookie = 'smsnotification';
export const smsServicePhoneNumber = 'smsphonenumber';
export const smsServiceMode = 'smsmode';
